import React, { Component } from "react";
import * as firebase from "firebase";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { Select } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
class AircraftStatusRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resourceName: this.props.resource,
      status: this.props.status,
      hobbsTime: this.props.hobbsTime,
      tachTime: this.props.tachTime,
      aircraftType: this.props.aircraftType,
      nextEventName: this.props.nextEventName,
      nextEventTime: this.props.nextEventTime,
    };
    this.setSettings = this.setSettings.bind(this);
    this.updateAircraft = this.updateAircraft.bind(this);
  }

  setSettings(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  updateAircraft() {
    let db = firebase.firestore();
    let a = this;
    let docRef = db.collection("aircraft").doc(this.state.resourceName);
    docRef.update({
      status: a.state.status,
      nextEventName: a.state.nextEventName,
      nextEventTime: a.state.nextEventTime,
    });
  }
  render() {
    return (
      <TableRow>
        <TableCell>{this.state.resourceName}</TableCell>
        <TableCell>{this.state.aircraftType}</TableCell>
        <TableCell>{this.state.status}</TableCell>
        <TableCell>{this.state.hobbsTime}</TableCell>
        <TableCell>{this.state.tachTime}</TableCell>
        <TableCell>{this.state.nextEventName}</TableCell>
        <TableCell>{this.state.nextEventTime}</TableCell>
        <TableCell>{this.state.nextEventTime - this.state.tachTime}</TableCell>
      </TableRow>
    );
  }
}

export default AircraftStatusRow;
